import { render } from "./MarketPlaceView.vue?vue&type=template&id=36de2498&scoped=true"
import script from "./MarketPlaceView.vue?vue&type=script&lang=js"
export * from "./MarketPlaceView.vue?vue&type=script&lang=js"

import "./MarketPlaceView.vue?vue&type=style&index=0&id=36de2498&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36de2498"]])

export default __exports__